<ng-container *transloco="let t">
  <div class="certificate-form">
    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Title') }}</mat-label>
      <textarea matInput rows="2" [formControl]="title"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Note') }}</mat-label>
      <textarea matInput rows="6" [formControl]="note"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput [formControl]="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
